import { Box, Image, Text, Link as ChakraLink } from '@chakra-ui/react';
import useAppTheme from 'hooks/shared/useAppTheme';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import TagsRow from 'presentation/components/shared/TagsRow';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import AppRoute from 'router/AppRoute';
import { Link as ReactRouterLink } from 'react-router-dom';
interface Props {
  article: ArticleListItem;
  color: string;
}

const ArticleListItemCard: FC<Props> = ({ article, color }) => {
  const theme = useAppTheme();

  const cardHeight = '320px';

  return (
    <ChakraLink as={article.isPrivate ? ReactRouterLink : undefined} to={AppRoute.privateChannelArticleComments(article.id, article.isCommentable)} href={article.isPrivate ? undefined : article.url} target="_blank" rel="noreferrer">
      <AppCard
        pos="relative"
        w="full"
        h={cardHeight}
        overflow="hidden"
      >
        <Image
          zIndex={1}
          src={article.image?.url ?? article.gallery[0].url ?? ''}
          pos="absolute"
          h={cardHeight}
          w="full"
          objectFit="cover"
        />
        <Box
          zIndex={2}
          pos="absolute"
          h={cardHeight}
          w="full"
          bgImage="linear-gradient(181.93deg,rgba(57,57,57,0) 1.63%,hsla(0,0%,7%,.7) 67.7%)"
          borderRadius="16px"
        />
        <Box
          p="15px"
          pos="relative"
          zIndex={3}
          h={cardHeight}
          display="flex"
          flexDir="column"
          justifyContent="flex-end"
        >
          <Text color="#fff" mb="2px" fontSize={FontSize.sm}>
            {moment(article.publicDate).format('DD.MM.yyyy')}
          </Text>
          <Text color="#fff" mb="2px" fontSize="18px" fontWeight={800}>
            {article.name}
          </Text>
          <Text color="#fff" fontSize={FontSize.sm}>
            {article.description}
          </Text>
          {article.tags && (
            <TagsRow
              tagColor={theme.colors[Color.Primary500]}
              tags={article.tags}
              mt="10px"
            />
          )}
        </Box>
      </AppCard>
    </ChakraLink>
  );
};

export default ArticleListItemCard;
